module.exports = __webpack_public_path__ + "static/media/bkg-1-dsk.2e88538c.jpg";